import { Button, Typography } from "@material-ui/core";

import MeditocPopover from "../../../utils/MeditocPopover";
import { useCallCenter } from "../../../../context/CallCenterContext";

export default function HelperOcupado() {
    const {
        popoverOcupado,
        handleChangePopoverOcupado,
        handleClickCloseInicio,
        handleClickCloseDisponible,
    } = useCallCenter();

    return (
        <MeditocPopover open={popoverOcupado} setopen={handleChangePopoverOcupado}>
            <Typography variant="body2" paragraph>
                TU ESTATUS ACTUAL ES OCUPADO.
            </Typography>
            <Typography variant="body2" paragraph>
                Un paciente intentó entrar a tu sala pero <br />
                la conexión no fue exitosa.
                <br />
                <br />
                Cambia tu estatus a DISPONIBLE para
                <br />
                continuar recibiendo llamadas.
            </Typography>
            <Button color="default" style={{ color: "#888" }} onClick={handleClickCloseInicio}>
                <Typography variant="body2">CONTINUAR OCUPADO</Typography>
            </Button>
            <Button color="primary" onClick={handleClickCloseDisponible}>
                <Typography variant="body2">CAMBIAR A DISPONIBLE</Typography>
            </Button>
        </MeditocPopover>
    );
}
